<template>
  <!-- 公告信息 -->
  <div class="noticeList full-height bg-lightGray">
    <ld-header>阅读消息</ld-header>

    <van-tabs
      v-model="active"
      line-width="20px"
      line-height="2px"
      animated
      swipeable
      sticky
    >
      <van-tab
        v-for="(tab, i) in tabList"
        :name="i"
        :key="tab.id"
        :title="`${tab.title} (${tab.total})`"
      >
        <div class="wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down" 
          >
            <van-pull-refresh
              v-model="tab.pullRefreshLoading"
              @refresh="onRefresh(tab)"
            >
              <van-list
                v-model="tab.loading"
                :finished="tab.finished"
                :error.sync="tab.error"
                :error-text="tab.errorText"
                :finished-text="tab.finishedText"
                @load="tab.pageNum++; getNoticeList(tab);"
              >
                <van-panel
                  class="notice-panel"
                  v-for="notice in tab.list"
                  :key="notice.tzId"
                  @click="$router.push({ path: `/userCenter/noticeDetail/${notice.id}` })"
                >
                  <div slot="header">
                    <van-row 
                      type="flex"
                      align="center"
                    >
                      <van-col>
                        <h3>{{ notice.tzTitle }}</h3>
                      </van-col>
                    </van-row>
                  </div>

                  <div
                    class="van-multi-ellipsis--l2 gray"
                    style="margin: 8px; 0"
                  >
                    {{ notice.ydContent }}
                  </div>

                  <div
                    slot="footer"
                    class="text-right"
                  >
                    发布时间： {{ notice.savedate }}
                  </div>
                </van-panel>
              </van-list>
            </van-pull-refresh>
          </mescroll-vue>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Panel, Tab, Tabs, List, Button, Field, PullRefresh } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import NoticeInteractor from '@/business/Domain/use-cases/notice-interactor'
import { mapGetters } from 'vuex'

export default {
  name: 'NoticeList',
  components: {
    [Panel.name]: Panel,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Field.name]: Field,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    MescrollVue
  },
  data () {
    return {
      active: 0,
      tabList: [
        {
          pageNum: 0,
          count: 10,
          loading: false,
          finished: false,
          finishedText: '没有更多数据了~',
          error: false,
          errorText: '请求失败，点击重新加载',
          list: [],
          pullRefreshLoading: false,
          title: this.$t('A136','未读'),
          status: 0,
          total: 0
        },
        {
          pageNum: 0,
          count: 10,
          loading: false,
          finished: false,
          finishedText: '没有更多数据了~',
          error: false,
          errorText: '请求失败，点击重新加载',
          list: [],
          pullRefreshLoading: false,
          title: this.$t('A135','已读'),
          status: 1,
          total: 0
        }
      ],
      down:{ use: false },
      noticeType:[],
    }
  },
  computed: {
    ...mapGetters({
      badgeDotCount: 'badgeDotCount'
    }),
  },
  created () {
    this.active = Number(this.$route.query.active) || 0
    
    this.tabList[0].total = this.badgeDotCount.message
    this.tabList[1].total = this.badgeDotCount.messaged
  },
  methods: {
    onRefresh(tab) {
      tab.list = []
      tab.pageNum = 1
      tab.pullRefreshLoading = false
      this.getNoticeList(tab)
    },
    async getNoticeList (tab) {
      if (tab.pageNum === 0) return
      tab.loading = true
      
      const { data } = await NoticeInteractor.getNoticeList(tab.status, tab.pageNum, tab.count)
      tab.loading = false

      if (!data.list || data.list.length < tab.count) {
        tab.finished = true
      }

      if (tab.pageNum > 1) {
        tab.list.push(...data.list)
      } else {
        tab.list = data.list
      }

      this.tabList[this.active].total = data.total
    },
  },
  activated () {
    this.onRefresh(this.tabList[this.active])
  }
}
</script>

<style lang="less" scoped>
.noticeList {
  h3 {
    margin: 0;
  }

  .wrapper {
    height: calc(100vh - 107px);
    overflow: hidden;
  }

  .van-tab__pane {
    font-size: @font-size-12;
  }

  .notice-panel {
    overflow: auto;
    margin: 25px;
    padding: 12px 12px 0;
    border-radius: 10px;
  }
}
</style>
